module.exports = __webpack_public_path__ + "static/media/010_fueru.ad2e66ff.gif";